import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNoteSticky } from '@fortawesome/pro-solid-svg-icons';
import { useTranslation } from 'react-i18next';

/**
 * Auffällige „Kundennotiz" im Stil eines Notizzettels (warmes Gelb, linker Akzent).
 * Wird beim Laden einer Kalkulation oben angezeigt, sofern der Kunde eine Notiz hinterlegt hat.
 */
export const CustomerNoteBanner: React.FC<{ note?: string | null }> = ({ note }) => {
    const { t } = useTranslation();
    if (!note || !note.trim()) return null;
    return (
        <Paper
            elevation={0}
            sx={(theme) => ({
                p: 2,
                mb: 2,
                borderRadius: 1,
                borderLeft: `6px solid ${theme.palette.warning.main}`,
                backgroundColor:
                    theme.palette.mode === 'light' ? '#FFFBEB' : alpha(theme.palette.warning.main, 0.12),
            })}
        >
            <Stack direction="row" spacing={1.5} sx={{ alignItems: 'flex-start' }}>
                <Box sx={{ color: 'warning.main', mt: 0.25 }}>
                    <FontAwesomeIcon icon={faNoteSticky} />
                </Box>
                <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
                        {t('calculation.customerNote', 'Kundennotiz')}
                    </Typography>
                    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                        {note}
                    </Typography>
                </Box>
            </Stack>
        </Paper>
    );
};

export default CustomerNoteBanner;
